var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('SearchPaginationTable',{ref:"table",attrs:{"pageData":_vm.pageData},on:{"handleClick":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }